import ExpandableBox from "./ExpandableBox";

export default ExpandableBox;
